import { render, staticRenderFns } from "./comPagination.vue?vue&type=template&id=0a374c66&"
import script from "./comPagination.vue?vue&type=script&lang=js&"
export * from "./comPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports